import { Redirect } from 'expo-router';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { routes } from 'utils/routing';

export const useWalmartDisabledRedirect = () => {
  const enableWalmartPlusIntegration = useFlag(LaunchDarklyFlag.ENABLE_WALMART_PLUS_INTEGRATION);
  if (!enableWalmartPlusIntegration) {
    return <Redirect href={routes.base} />;
  }
  return null;
};
